import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes__default from 'prop-types';
import { textStyleType } from '../../common/PropShapes.js';
import StreamlineIcon from '../../widgets/streamline-icon/StreamlineIcon.js';
import SvgEmailActionUnread from '../../common/streamlinehq/img/streamline-regular/emails/email-actions/email-action-unread.svg.js';
import SvgPhone from '../../common/streamlinehq/img/streamline-regular/phones-mobile-devices/phone/phone.svg.js';
import { Box, Grid, Link } from '@material-ui/core';
import clsx from 'clsx';
import Skeleton from '@material-ui/lab/Skeleton';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    avatar: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      borderRadius: "50%",
      marginBottom: theme.spacing(0.5)
    },
    box: {
      padding: theme.spacing(5, 0),
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    contactInfo: _defineProperty({
      alignItems: "flex-start",
      justifyContent: "center"
    }, theme.breakpoints.up("md"), {
      alignItems: "center",
      justifyContent: "flex-start"
    }),
    name: {
      fontWeight: "600"
    },
    role: {
      color: theme.palette.text["disabled"]
    },
    disclaimerText: _objectSpread(_objectSpread({}, theme.typography.caption), {}, {
      textAlign: "center"
    }),
    heading: {
      padding: theme.spacing(0, 5),
      maxWidth: theme.spacing(70)
    },
    hyperlink: {
      color: theme.palette.text.black,
      textDecorationLine: "underline",
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "140%",
      cursor: "pointer"
    },
    inlineIcon: {
      verticalAlign: "top"
    },
    inlineLabel: {
      display: "inline-block",
      verticalAlign: "sub",
      textAlign: "left",
      marginLeft: theme.spacing(2)
    },
    mb0point5: {
      marginBottom: theme.spacing(0.5)
    },
    mb1point5: {
      marginBottom: theme.spacing(1.5)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mr1point5: {
      marginRight: theme.spacing(1.5)
    },
    mr2: {
      marginRight: theme.spacing(2)
    },
    mt5: {
      marginTop: theme.spacing(5)
    },
    phoneLink: {
      color: theme.palette.text.black,
      "&:hover": {
        textDecoration: "none"
      }
    },
    subtitleText: _objectSpread(_objectSpread({}, theme.typography.overline), {}, {
      marginBottom: theme.spacing(5)
    }),
    columnAvatar: _defineProperty({
      marginTop: theme.spacing(5)
    }, theme.breakpoints.up("md"), {
      marginTop: theme.spacing(5),
      marginRight: theme.spacing(4),
      marginLeft: theme.spacing(-1.5)
    })
  };
});
var ContactUs = function ContactUs(_ref) {
  var loading = _ref.loading,
    imgTitle = _ref.imgTitle,
    imgUrl = _ref.imgUrl,
    title = _ref.title,
    subtitle = _ref.subtitle,
    titleStyle = _ref.titleStyle,
    subtitleStyle = _ref.subtitleStyle,
    contactImageTitle = _ref.contactImageTitle,
    contactImageUrl = _ref.contactImageUrl,
    firstAndLastName = _ref.firstAndLastName,
    role = _ref.role,
    serviceNumber = _ref.serviceNumber,
    phone = _ref.phone,
    workingHours = _ref.workingHours,
    email = _ref.email,
    bottomText = _ref.bottomText;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !loading ? /*#__PURE__*/React__default.createElement(Box, {
    className: classes.box
  }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imgUrl, {
      width: 136,
      height: 136
    }),
    className: classes.mb1point5,
    alt: imgTitle || ""
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle && titleStyle.headingVariant ? titleStyle.headingVariant : "h3",
    component: "h2",
    align: titleStyle && titleStyle.textAlignment ? titleStyle.textAlignment.toLowerCase() : "center",
    color: "textSecondary",
    className: classes.heading
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    variant: subtitleStyle && subtitleStyle.headingVariant ? subtitleStyle.headingVariant : "caption",
    align: subtitleStyle && subtitleStyle.textAlignment ? subtitleStyle.textAlignment.toLowerCase() : "center",
    color: "textSecondary",
    className: classes.subtitleText
  }, subtitle), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    md: 3,
    xs: 12,
    className: classes.columnAvatar
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: classes.avatar,
    src: retrieveContentfulImage(contactImageUrl, {
      width: 240,
      height: 240
    }),
    alt: contactImageTitle || ""
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    className: classes.name
  }, firstAndLastName), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    className: classes.role
  }, role)))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    md: 8,
    xs: 11,
    className: classes.mt5
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row",
    className: clsx(classes.contactInfo)
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(StreamlineIcon, {
    className: classes.inlineIcon
  }, /*#__PURE__*/React__default.createElement(SvgPhone, null)), /*#__PURE__*/React__default.createElement("div", {
    className: classes.inlineLabel
  }, serviceNumber && /*#__PURE__*/React__default.createElement(Link, {
    href: "tel:".concat(serviceNumber),
    className: classes.hyperlink,
    variant: "body1"
  }, serviceNumber + "*"), phone && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    className: classes.mb0point5
  }, phone), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    className: classes.mb2
  }, workingHours)))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    direction: "row",
    className: classes.contactInfo
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(StreamlineIcon, {
    className: classes.inlineIcon
  }, /*#__PURE__*/React__default.createElement(SvgEmailActionUnread, null)), email && /*#__PURE__*/React__default.createElement(Link, {
    href: "mailto:".concat(email),
    className: clsx(classes.inlineLabel, classes.hyperlink),
    variant: "body1"
  }, email))))), /*#__PURE__*/React__default.createElement(Typography, {
    className: clsx(classes.disclaimerText, classes.mt5),
    color: "textSecondary"
  }, bottomText))) : /*#__PURE__*/React__default.createElement(Box, {
    className: classes.box
  }, /*#__PURE__*/React__default.createElement(Skeleton, {
    variant: "rect",
    width: 560,
    height: 400
  })));
};
ContactUs.propTypes = {
  loading: PropTypes__default.bool,
  imgTitle: PropTypes__default.string,
  imgUrl: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  titleStyle: PropTypes__default.shape(textStyleType),
  subtitleStyle: PropTypes__default.shape(textStyleType),
  contactImageTitle: PropTypes__default.string,
  contactImageUrl: PropTypes__default.string,
  firstAndLastName: PropTypes__default.string,
  role: PropTypes__default.string,
  serviceNumber: PropTypes__default.string,
  phone: PropTypes__default.string,
  workingHours: PropTypes__default.string,
  email: PropTypes__default.string,
  bottomText: PropTypes__default.string
};

export { ContactUs as default };
//# sourceMappingURL=ContactUs.js.map
